import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { Button } from 'react-native-paper';
import LoadingImage from './LoadingImage';

interface HeaderBarProps {
  buttonLabel?: string;
  onButtonPress?: () => void;
  rightContent?: React.ReactNode;
  style?: any;
  onLogoPress?: () => void;
  compact?: boolean;
}

const HeaderBar: React.FC<HeaderBarProps> = ({ buttonLabel, onButtonPress, rightContent, style, onLogoPress, compact }) => (
  <View style={[styles.headerContainer, style]}>
    <TouchableOpacity
      style={[styles.logoContainer, compact ? styles.logoContainerCompact : null]}
      onPress={onLogoPress}
      activeOpacity={onLogoPress ? 0.7 : 1}
    >
      <LoadingImage 
        source={require('../../assets/logo-transparent.png')}
        style={styles.logo}
        contentFit="contain"
        transition={200}
        cachePolicy="memory-disk"
      />
    </TouchableOpacity>
    <View style={styles.headerRight}>
      {buttonLabel && onButtonPress && (
        <Button
          mode="contained"
          onPress={onButtonPress}
          style={styles.actionButton}
        >
          {buttonLabel}
        </Button>
      )}
      {rightContent}
    </View>
  </View>
);

const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
  },
  logoContainer: {
    width: 90,
    height: 90,
    justifyContent: 'center',
    alignItems: 'center',
  },
  logoContainerCompact: {
    width: 72,
    height: 72,
  },
  logo: {
    width: '100%',
    height: '100%',
  },
  headerRight: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  actionButton: {
    backgroundColor: '#000',
  },
});

export default HeaderBar; 